import React from 'react';
import FilterItem from './FilterItem';

import { PageMode } from '../../../Basepage/parts/Definitions';
import iconFilterX from './images/icon-filter-x.svg';
import {
  replaceAllComplex,
  splitNumberThousands,
} from '../../../../../../mol_function';
import { SearchPageSortParams } from '../..';
import ResultRedirect from '../../../Basepage/parts/ResultRedirect';
import { endPopup, startPopup } from '../../../Basepage';
import { showForceLagerFilter, showKeywordFilter } from '../../overrides';

export interface FilerTranslateItem {
  field: string;
  caption: string;
  mode?: string;
  fieldPrefix?: string;
  sort?: string;
  prio: number;
  custom_id?: number;
}

interface FilterRowProps {
  filterData: any;
  filterTranslate: FilerTranslateItem[];
  queryParams: any;
  pageMode: PageMode;
  totalItems: number;
  apiBase: string;
}

interface FilterRowState {
  mobileMenuIsOpen: boolean;
  filterData: any;
  filterTranslate: FilerTranslateItem[];
  queryParams: any;
  totalItems: number;
  pendingUrl?: string;
}
export default class FilterRow extends React.Component<
  FilterRowProps,
  FilterRowState
> {
  //history: any;
  filterItems: any;

  constructor(props: FilterRowProps) {
    super(props);
    this.filterItems = {};
    this.state = {
      mobileMenuIsOpen: false,
      filterData: props.filterData,
      filterTranslate: props.filterTranslate,
      queryParams: props.queryParams,
      totalItems: props.totalItems,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProp: any, prevState: any) {
    let jsonqueryParams = JSON.stringify(this.props.queryParams);
    let jsonOldqueryParams = JSON.stringify(prevProp.queryParams);

    if (jsonqueryParams != jsonOldqueryParams) {
      this.setState({ pendingUrl: undefined });
    }
  }

  render() {
    let filterCount = 0;
    let ftiArray = this.state.filterTranslate;
    let filterData = this.state.filterData;
    let filtersValues = this.state.queryParams;

    let mobileVersion = this.props.pageMode == PageMode.Mobile;

    let ftiArrayLevels: FilerTranslateItem[][] = [];

    let maxLevel = 0;

    if (ftiArray == null || ftiArray == undefined) ftiArray = [];

    for (let i = 0; i < ftiArray.length; i++) {
      let level = (ftiArray[i].prio / 100) | 0;
      if (mobileVersion) level = 0;

      if (level > maxLevel)
        if (
          filterData[ftiArray[i].field] != undefined &&
          Object.keys(filterData[ftiArray[i].field]).length > 1
        )
          maxLevel = level;

      if (ftiArrayLevels[level] == undefined) {
        ftiArrayLevels.push([]);
      }
      ftiArrayLevels[level].push(ftiArray[i]);
    }

    let keywordValue = '';
    if (filtersValues.keyword != undefined && filtersValues.keyword != '*') {
      keywordValue = filtersValues.keyword;
    }

    let gui = null;
    let filterListe = (
      <div id="filterNavWraper">
        {ftiArrayLevels.map(
          (ftiArrayLevel: FilerTranslateItem[], indexLevel) => {
            let className = 'ul';

            if (indexLevel > 0) className = className + ' extra';
            return (
              <div key={'level' + indexLevel} className={className}>
                {ftiArrayLevel.map((item, index) => {
                  let filterPosibleValue = filterData[item.field];
                  let filterPrefix = 'fqZZZ';
                  if (item.fieldPrefix != undefined) {
                    filterPrefix = item.fieldPrefix;
                  }

                  let filterKey = filterPrefix + item.field;

                  let posibleValue = 0;

                  if (filterPosibleValue != undefined)
                    posibleValue = Object.keys(filterPosibleValue).length;

                  let showItem =
                    posibleValue > 1 ||
                    (showForceLagerFilter() &&
                      item.field == 'Lager' &&
                      posibleValue > 0);

                  if (mobileVersion && posibleValue > 0) showItem = true;

                  let filterItemsArray = this.filterItems;

                  let filtersValue = filtersValues[filterKey];

                  if (showItem) {
                    filterCount = filterCount + 1;
                    return (
                      <FilterItem
                        key={'FilterItem' + indexLevel + '_' + index}
                        fti={item}
                        filterPosibleValules={filterPosibleValue}
                        filterValue={filtersValue}
                        filterOpen={() => {
                          this.closeAllFilter();
                        }}
                        fip_index={indexLevel + '_' + index}
                        ref={(r: any) => {
                          if (r != null) {
                            let filterPrefix = 'fqZZZ';
                            if (item.fieldPrefix != undefined)
                              filterPrefix = item.fieldPrefix;
                            filterItemsArray[filterPrefix + item.field] = r;
                          }
                        }}
                        updateFilter={(
                          fti: FilerTranslateItem,
                          newFilterValue: string,
                          historyHandle: any,
                        ) => {
                          this.updateFilterHandler(
                            fti,
                            newFilterValue,
                            historyHandle,
                          );
                        }}
                        isMobileMenu={mobileVersion}
                      ></FilterItem>
                    );
                  }
                })}

                <div className="filterItem weitereFilter">
                  {showKeywordFilter() ? (
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        let filterValue: string =
                          $(e.target).find('input').val()?.toString() ?? '';

                        let updateHandler: any = null;

                        let windowAny: any = window;

                        if (
                          windowAny.historyHelper != undefined &&
                          windowAny.historyHelper.memory != undefined
                        )
                          updateHandler = windowAny.historyHelper.memory;

                        this.updateFilterHandler(
                          {
                            field: 'keyword',
                            caption: '',
                            prio: 0,
                            fieldPrefix: '',
                          },
                          filterValue,
                          updateHandler,
                        );
                      }}
                    >
                      {indexLevel == 0 ? (
                        <li className="keyword">
                          <input
                            placeholder="Suchbegriff"
                            defaultValue={replaceAllComplex(keywordValue, [
                              { s: '+', r: ' ' },
                              { s: '___', r: '/' },
                              { s: '_', r: ' ' },
                              { s: '%3F', r: '?' },
                              { s: '%26', r: '&' },
                            ])}
                          ></input>
                        </li>
                      ) : null}
                    </form>
                  ) : null}
                  {indexLevel == 0 && maxLevel > 0 && !mobileVersion ? (
                    <div
                      className="li"
                      onClick={() => {
                        $('#filterNavWraper div.ul.extra').toggleClass(
                          'showAll',
                        );
                      }}
                    >
                      weitere Filter
                    </div>
                  ) : null}
                </div>
              </div>
            );
          },
        )}
      </div>
    );

    if (!mobileVersion) {
      gui = filterListe;
    } else {
      if (!this.state.mobileMenuIsOpen) {
        gui = (
          <div
            id="filterClosed"
            onClick={() => {
              this.openMobileMenu();
            }}
          >
            Filtern nach
          </div>
        );
      } else {
        gui = (
          <div id="mobileFilterPopup" className="popUp">
            <div id="mobileFilterPopupWarper">
              <div className="filterHeader">
                Filtern nach
                <img
                  src={iconFilterX}
                  className="closeIMG"
                  onClick={() => {
                    this.closeMobileMenu();
                  }}
                />
              </div>

              {filterListe}
              <div id="filterFooterWarper">
                <div
                  id="filterFooter"
                  onClick={() => {
                    this.closeMobileMenu();
                  }}
                >
                  <div>
                    Filter anwenden {'>>'} Ergebnisse:{' '}
                    {splitNumberThousands(this.state.totalItems)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }

    return (
      <div id="filterNav">
        {this.state.pendingUrl != undefined ? (
          <ResultRedirect itemLink={this.state.pendingUrl} />
        ) : null}
        {gui}
      </div>
    );
  }

  openMobileMenu() {
    startPopup();

    this.setState({ mobileMenuIsOpen: true });
  }

  closeMobileMenu() {
    endPopup();
    this.setnewFilterToPageLoader();
    this.setState({ mobileMenuIsOpen: false });
  }

  updateFilterHandler(
    fti: FilerTranslateItem,
    newFilterValue: string,
    historyHandle: any,
  ) {
    let newQuery = this.state.queryParams;
    let filterPrefix = 'fqZZZ';
    if (fti.fieldPrefix != undefined) filterPrefix = fti.fieldPrefix;

    if (newFilterValue == '') {
      delete newQuery[filterPrefix + fti.field];
    } else {
      newQuery[filterPrefix + fti.field] = newFilterValue;
    }

    delete newQuery['page'];

    let newQueryString = '';

    let newQueryStringArray: string[] = [];

    let keys = Object.keys(newQuery);
    for (let i = 0; i < keys.length; i++) {
      let value = decodeURIComponent(
        replaceAllComplex(newQuery[keys[i]], [{ s: '%2F', r: '___' }]),
      );
      newQueryStringArray.push(keys[i] + '=' + encodeURIComponent(value));
    }
    newQueryString = '?' + SearchPageSortParams(newQueryStringArray);

    if (this.props.pageMode == PageMode.Mobile) {
      let baseUrl =
        this.props.apiBase +
        '/index.php?main_page=advanced_search_result&frame=api&';
      let req = baseUrl + newQueryString.substring(1);

      fetch(req)
        .then((response) => response.json())
        .then((data) => {
          let newstate = {
            filterData: data.body.filter,
            filterTranslate: data.body.filterTranslate,
            queryParams: newQuery,
            totalItems: data.body.numFound,
          };
          this.setState(newstate);
        });
    } else historyHandle.push('/search_page/' + newQueryString);
  }

  setnewFilterToPageLoader() {
    let newQuery = this.state.queryParams;
    let newQueryString = '';

    let newQueryStringArray: string[] = [];

    let keys = Object.keys(newQuery);
    for (let i = 0; i < keys.length; i++) {
      let value = decodeURIComponent(
        replaceAllComplex(newQuery[keys[i]], [{ s: '%2F', r: '___' }]),
      );
      newQueryStringArray.push(keys[i] + '=' + encodeURIComponent(value));
    }

    newQueryString = '?' + SearchPageSortParams(newQueryStringArray);

    this.setState({ pendingUrl: '/search_page/' + newQueryString });
  }

  closeAllFilter() {
    let keys = Object.keys(this.filterItems);
    for (let i = 0; i < keys.length; i++) {
      this.filterItems[keys[i]].closeMenu();
    }
  }
}
